export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="ReadTheRoom"
              className="h-24 w-24 rounded-lg object-cover"
            />
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-8">
            <a
              href="https://www.tiktok.com/@readtheroomng"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-sm text-cream/50 hover:text-cream transition-colors duration-300"
              data-testid="footer-tiktok-link"
            >
              TikTok
            </a>
            <a
              href="https://x.com/ReadRoom71219"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-sm text-cream/50 hover:text-cream transition-colors duration-300"
              data-testid="footer-x-link"
            >
              X
            </a>
            <a
              href="https://www.instagram.com/readtheroomng"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-sm text-cream/50 hover:text-cream transition-colors duration-300"
              data-testid="footer-instagram-link"
            >
              Instagram
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="my-10 h-px bg-cream/10" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-cream/30">
            &copy; {new Date().getFullYear()} ReadTheRoom. Made with love in Lagos.
          </p>
          <p className="font-body text-xs text-cream/20">
            Proudly Lagos. Ambitiously African.
          </p>
        </div>
      </div>
    </footer>
  );
}
